import { Button } from "components/Button";
import { InputFormField } from "components/InputFormField";
import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedFilters } from "components/TableModified/TableModifiedFilters";
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Container, TableSearchLocations } from "./styles";
import { useLocationsTable } from "./useLocationsTable";

const tableHead = [
  "Nome",
  "Descrição",
  "Capacidade",
  "Status",
  "Data de Criação",
];

export const LocationsTable: React.FC = () => {
  const {
    loading,
    error,
    properties,
    locationRows,
    locationsCount,
    searchText,
    tableFilters,
    searchTextFormRef,
    pageNumber,
    locationsPerPage,
    handleSearchTextFormSubmit,
    handleFilterChange,
    handleFilterRemove,
    handleSearchTextRemove,
    handlePageSelected,
    handleRowsPerPageChange,
    locations,
    getLocations,
  } = useLocationsTable();

  const { push } = useHistory();
  const { id: eventId } = useParams<{ id: string }>();

  const handleCreateLocation = () => {
    push(`/events/${eventId}/location/create`);
  };

  const handleEditLocation = (location: any) => {
    push(`/events/${eventId}/location/${location.locationId}/edit`);
  };

  return (
    <Container>
      <div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "end",
            justifyContent: "space-between",
            marginBottom: "1rem",
          }}
        >
          <TableSearchLocations
            className="table-search-locations"
            onSubmit={handleSearchTextFormSubmit}
            ref={searchTextFormRef}
            style={{ flex: 1 }}
          >
            <InputFormField
              label="Buscar locais"
              autoFocus={true}
              name="searchText"
              marginBotton={"0"}
              backGround={"white"}
              defaultValue={searchText}
              block={true}
            />
            <Button label="Buscar" typeBtn="blue" type="submit" block={false} />
          </TableSearchLocations>

          <Button
            label="Criar local"
            typeBtn="blue"
            onClick={handleCreateLocation}
            block={false}
          />
        </div>
      </div>

      <TableModifiedFilters
        filters={tableFilters}
        searchTextFilter={searchText}
        onFilterChange={handleFilterChange}
        onFilterRemove={handleFilterRemove}
        onSearchTextRemove={handleSearchTextRemove}
      />

      {loading ? (
        <Loading />
      ) : error ? (
        <PlaceHolderNotExists title="Erro ao se comunicar com o servidor" />
      ) : (
        <>
          <TableModifiedCards properties={properties} />
          <TableModifiedTable
            headerColumns={tableHead}
            rows={locationRows}
            onRowClick={(_, rowIndex) => {
              if (locations && locations[rowIndex]) {
                handleEditLocation(locations[rowIndex]);
              }
            }}
          />
        </>
      )}

      {locationsCount > 0 ? (
        <TableModifiedPagination
          totalItemsCount={locationsCount}
          pageNumber={pageNumber}
          rowsPerPage={locationsPerPage}
          onPageSelected={handlePageSelected}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      ) : null}
    </Container>
  );
};
